export default "__VITE_ASSET__B86Oe6L6__"